import Swiper, {Navigation} from 'swiper';
import 'swiper/css';
import domReady from '@wordpress/dom-ready';

domReady(function () {

	const editorContainer = document.querySelector('.editor-styles-wrapper');
	const adminContainer = document.querySelector('.wp-admin');
	const isAdmin = (!(editorContainer || adminContainer));

	const startCarousel = () => {
		const pagesCarouselParent = document.querySelectorAll('.page-carousel');
		pagesCarouselParent.forEach((slider, index) => {

			let Carousel = slider.querySelector('.swiper')
			let prev = slider.querySelector('.swiper-button-prev')
			let next = slider.querySelector('.swiper-button-next')

			const PagesCarousel = new Swiper(Carousel, {
				modules: [Navigation],
				slidesPerView: 1.6,
				spaceBetween: 20,
				observer: true,
				allowTouchMove: isAdmin,
				breakpoints: {
					480: {
						slidesPerView: 2.6,
					},
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					}
				},
				navigation: {
					nextEl: next,
					prevEl: prev,
				},
			});
		});
	}

	startCarousel();

	const checkCarousel = () => {
		const pagesCarouselParent = document.querySelectorAll('.page-carousel .swiper');
		pagesCarouselParent.forEach((slider, index) => {
			if (slider && !slider.matches('.swiper-initialized')) {
				startCarousel();
			}
		});
	}
	const checkCarouselInterval = setInterval(checkCarousel, 1000);

});
